import React from "react";
import swal from "sweetalert";

import { VIEWER_ZONE_DOMAIN } from "../../../config/defaults";
import sendToClipBoard from "../../../services/sendToClipboard";

import generatePassword from "../../../services/passwordGenerator";

const WebRTCData = ({ id, url, organized, webrtc_users, firebase }) => {
    console.log(id);
    const [email, setEmail] = React.useState("")
    const [password, setPassword] = React.useState("");
    const [WebRTC_Users, setWebRTC_Users] = React.useState(webrtc_users);
    const [isLoading, setLoadingStatus] = React.useState(false);

    const onNewUser = (e)=>{
        e.preventDefault();
        if (email === ""){
            swal("Error", "El email no puede estar vacío", "error");
        } else{
            if (password === ""){
                swal("Error", "La clave no puede estar vacía", "error");
            } else{
                setLoadingStatus(true);
                const doc = firebase.getDoc("events", id);
                doc.update({ webrtc_users: firebase.arrayUnion({email, password})})
                .then(()=>{
                    const _WebRTC_Users = [...WebRTC_Users] ;
                    _WebRTC_Users.push({ email, password });
                    setWebRTC_Users(_WebRTC_Users);
                    setLoadingStatus(false);
                });
            }
        }
    }

    const onDelete = (item)=>{
        const index = WebRTC_Users.indexOf(item);
        console.log(index);
        if (index >= 0){
            setLoadingStatus(true);
            const doc = firebase.getDoc("events", id);
            doc.update({ webrtc_users: firebase.arrayUnion(item) })
                .then(() => {
                    const _WebRTC_Users = [...WebRTC_Users];
                    _WebRTC_Users.splice(index, 1);
                    setWebRTC_Users(_WebRTC_Users);
                    setLoadingStatus(false);
                });
        }
    }

    return (
        <div className="col-sm-12 row-eq-height">
            <div className="card card-body card-dashboard-twentyone ht-xl-100p">
                <h6 className="card-title tx-14 mg-b-10">Estudio de transmisión online</h6>
                <p className="mg-b-5">Envía este enlace privado únicamente a tu conferencista o presentador. Recuerda que es un link confidencial que NO debe ser conocido por los invitados o espectadores de la transmisión.</p>
                <p className="mg-b-15">Tus invitados y espectadores podrán ver tu transmisión en este link: <a className="mr-3" href={`/${url}`} target="_blank" rel="noopener noreferrer">{VIEWER_ZONE_DOMAIN}/{url}</a> <button
                    className="btn btn-outline-primary"
                    onClick={() => {
                        sendToClipBoard(`${VIEWER_ZONE_DOMAIN}/${url}`, "El vínculo ha sido copiado");
                    }}>
                    <i className="fas fa-copy"></i>
                </button></p>

                <div className="table-responsive">
                    <table className="table table-hover mg-b-0">
                        <tbody>
                            <tr>
                                <td>Link al estudio de transmisión online:</td>
                                <td>
                                    <a className="mr-3" href={`/encoder/${organized}/${id}`} target="_blank" rel="noopener noreferrer">{VIEWER_ZONE_DOMAIN}/encoder/{organized}/{id}</a>
                                </td>
                                <td>
                                    <button
                                        className="btn btn-outline-primary"
                                        onClick={() => {
                                            sendToClipBoard(`${VIEWER_ZONE_DOMAIN}/encoder/${organized}/${id}`, "El vínculo ha sido copiado");
                                        }}>
                                        <i className="fas fa-copy" /> Copiar
                                </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h6 className="card-title mg-t-30">Usuarios Autorizados</h6>
                <form className="d-flex justify-content-between align-items-end" onSubmit={onNewUser}>
                    <div className="row flex-1 mg-r-15">
                        <div className="form-group col-sm-8">
                            <label className="form-label">Correo: </label>
                            <input className="form-control" type="email" value={email} onChange={(e) => setEmail(e.target.value)}/>
                        </div>
                        <div className="form-group col-sm-4">
                            <label className="form-label">Clave: </label>
                            <div className="d-flex align-items-center">
                                <input className="form-control" value={password} onChange={(e) => setPassword(e.target.value)}/>
                                <button type="button" className="btn btn-info" onClick={() => { setPassword(generatePassword(14))}}>
                                    <i className="fas fa-refresh" /> Generar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button type="submit" disabled={isLoading} className="btn btn-indigo">
                            <i className={"fas fa-plus" + (isLoading ? "spinner fa-spin" : "trash")} /> Agregar
                        </button>
                    </div>
                </form>
                <div className="row">
                    {WebRTC_Users.map((row)=>{
                        return (
                            <div className="row col-sm-12" key={row.email + "_" + row.password}>
                                <div className="col-md-6">{row.email}</div>
                                <div className="col-md-4">{row.password}</div>
                                <div className="col-md-2">
                                    <button disabled={isLoading } className="btn btn-danger" onClick={(e) => onDelete({email: row.email, password: row.password})}>
                                        <i className={"fas fa-" + (isLoading ? "spinner fa-spin" : "trash")} />
                                    </button>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default WebRTCData;